import { SelectPropsValue } from 'commons/components/form-elements/select';

export const getSingleSelectValue = (value: SelectPropsValue) => (Array.isArray(value) ? value[0] : value);
